<template>
  <div class="w-100 mt-4">
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title text-primary"><strong>FLEET REPORT (CURRENT CONDITION)</strong></h4>
      </template>
      <template #body>
        <!-- <date-picker class="mb-2" style="width: 220px" range v-model="dateRange"
          @input="fetchFleetReports"></date-picker> -->
        <div class="d-flex overflow-auto pb-3" v-if="!loading">
          <div class="card-container cursor-pointer shadow-sm" v-for="(item, index) in fleetReports"
            style="min-width: 24%; margin-right: 1%;" :key="index" :md="`${item.cols * 2}`">
            <div class="p-2 py-3 card-title-wrap d-flex align-items-center px-3" v-b-toggle="`collapse-fleet-report-${index}`"
              :class="fleetsStatus.find(i => i.title == item.title)?.bg" style="border-radius: 10px">
              <!-- <div class="mr-3">
                <OperationalIcon />
              </div> -->
              <div>
                <strong class="p-0 m-0 text-yellow">{{ item.title }}</strong>
                <h4 class="text-white">{{ item.detail }} Fleets</h4>
              </div>
            </div>
            <img v-if="item.title == 'Heavy Equipment'"
              :src="require(`../../../assets/images/icon/heavy-equipment.svg`)" width="90" alt="" class="card-image"
              style="top: 34px" />
            <img v-else :src="require(`../../../assets/images/icon/ship-3d.png`)" width="78" alt=""
              class="card-image" />
            <b-collapse :id="`collapse-fleet-report-${index}`" >
              <div class="mt-2">
                <template v-if="item.title == 'Heavy Equipment'">
                  <div class="py-1 px-3 d-flex justify-content-between bg-striped">
                    <h6>Active</h6>
                    <h6>{{ item?.data?.active }}</h6>
                  </div>
                  <div class="py-1 px-3 d-flex justify-content-between">
                    <h6>Breakdown</h6>
                    <h6>{{ item?.data?.breakdown }}</h6>
                  </div>
                </template>
                <template v-else>
                  <div v-for="(tableData, i) in item.data" :key="i" class="py-1 px-3 d-flex justify-content-between"
                    :class="{ 'bg-striped': i % 2 == 0 }" @click="() => showDetailFleet(tableData)">
                    <h6>{{ tableData.name }}</h6>
                    <h6>{{ tableData.total_vehicle }}</h6>
                  </div>
                </template>
              </div>
            </b-collapse>
          </div>
        </div>
        <div class="d-flex w-100 justify-content-center my-5" v-else>
          <b-spinner style="height: 80px; width: 80px;"></b-spinner>
        </div>
      </template>
    </iq-card>
    <b-modal v-model="showModalDetailFleet" id="add-init" size="xl" title="FLEETS" header-bg-variant="light" header-text-variant="dark" footer-bg-variant="light" footer-text-variant="dark">
      <div style="max-height: 80vh; overflow-y: auto; overflow-x: hidden;">
          <b-row class="mb-4 align-items-end">
            <b-col md="4">
              <b-form-input type="text" placeholder="Search fleets..." v-model="searchFleet" @input="onSearchInput"></b-form-input>
            </b-col>
            <b-col md="8" class="d-flex justify-content-end align-items-center">
              <h6 class="mr-2 mb-0">View :</h6>
              <b-button-group>
                <b-button @click="modalView = 'list'" class="p-2 px-3 button-view" :variant="modalView === 'list' ? 'primary' : 'outline-primary'">
                  <i class="fa m-0 fa-bars"></i>
                </b-button>
                <b-button @click="modalView = 'large'" class="p-2 px-3 button-view" :variant="modalView === 'large' ? 'primary' : 'outline-primary'">
                  <i class="fa m-0 fa-th-large"></i>
                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
          <div v-if="loading_fleet" class="text-center my-5">
          <b-spinner type="grow" label="Spinning"></b-spinner>
          </div>
          <template v-else>
            <!-- Large cards view -->
            <b-row v-if="modalView === 'large' && fleets?.length > 0">
                <b-col md="3" class="text-center py-5 border-top" v-for="(fleet, i) in fleets" :key="`fleet-${i}`">
                  <div class="custom-control custom-radio image-checkbox">
                      <!-- <input :id="`ck-fl-${i}`" type="radio" class="custom-control-input" :value="fleet.id" v-model="checkedFleets" /> -->
                      <label class="custom-control-label" :for="`ck-fl-${i}`">
                        <img :src="
                            fleet.vehicleType.icon.url
                            | checkPhoto(
                                require('@src/assets/images/fleet/PusherBarge.png')
                            )
                        " alt="#" class="img-fluid" />
                      </label>
                      <small>
                        <strong>{{ fleet.name }}</strong>
                      </small>
                  </div>
                </b-col>
            </b-row>
            <!-- List table view -->
             <div  v-else-if="modalView === 'list' && fleets?.length > 0" class="border-top overflow-auto">
               <div class="table-responsive">
                 <table class="table table-striped mb-0">
                   <thead>
                     <tr>
                       <!-- <th style="width: 48px"></th> -->
                       <th>Name</th>
                       <th>Type</th>
                       <th>Code</th>
                       <th>Status</th>
                     </tr>
                   </thead>
                   <tbody>
                     <tr v-for="(fleet, i) in fleets" :key="`fleet-row-${i}`">
                       <!-- <td>
                         <b-form-radio :value="fleet.id" v-model="checkedFleets" :id="`ck-fl-list-${i}`"></b-form-radio>
                       </td> -->
                       <td>{{ fleet.name }}</td>
                       <td>{{ fleet.vehicleType?.name || '-' }}</td>
                       <td>{{ fleet.code || '-' }}</td>
                       <td>
                         <b-badge :variant="fleet.active ? 'success' : 'secondary'">{{ fleet.active ? 'Active' : 'Inactive' }}</b-badge>
                       </td>
                     </tr>
                   </tbody>
                 </table>
               </div>
             </div>
            <div v-else class="text-center my-5">
                <p class="mb-0 text-muted">No fleets data found.</p>
            </div>
          </template>
        </div>
        <template #modal-footer="{ cancel }">
        <b-row>
            <b-col md="12" class="text-center">
            <b-button variant="none" class="iq-bg-danger text-right" @click="cancel">Cancel</b-button>
            <b-button variant="secondary" class="ml-2 text-right" :disabled="page <= 1" v-if="page > 1" @click="prevPage">
                <span>Back <i class="fa fa-arrow-left"></i></span>
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2 text-right" @click="nextPage" :disabled="totalPages === 1">
                <span
                v-if="nextLoading"
                class="spinner-border spinner-border-sm"
                />

                <span v-else>Next <i class="fa fa-arrow-right"></i></span>
            </b-button>
            </b-col>
        </b-row>
        </template>
    </b-modal>
  </div>
</template>
<script>
import { srActions, vehiclesActions } from '@/src/Utils/helper'
import BreakdownIcon from '../IconsTabMenus/BreakdownIcon.vue'
import DockingIcon from '../IconsTabMenus/DockingIcon.vue'
import HeavyIcon from '../IconsTabMenus/HeavyIcon.vue'
import OperationalIcon from '../IconsTabMenus/OperationalIcon.vue'
import moment from '@/node_modules/moment/moment'

export default {
  name: 'SummaryFleetStatus',
  components: {
    OperationalIcon,
    BreakdownIcon,
    DockingIcon,
    HeavyIcon,
  },
  data() {
    return {
      collapse: true,
      loading: false,
      dateRange: [
        moment().startOf('year').toDate(),
        moment().endOf('year').toDate()
      ],
      fleetsStatus: [
        {
          title: 'Total Fleet',
          total: '124/200 Vessels',
          bg: 'active-bg',
          icon: OperationalIcon,
          cols: 3,
        },
        {
          title: 'Fleet in Operation',
          total: '124/200 Vessels',
          bg: 'standby-bg',
          icon: OperationalIcon,
          cols: 3,
        },
        {
          title: 'Fleet Breakdown',
          total: '14 Vessels',
          bg: 'breakdown-bg',
          icon: BreakdownIcon,
          cols: 3,
        },
        {
          title: 'Docking',
          total: '2 Vessels',
          bg: 'progress-bg',
          icon: DockingIcon,
          cols: 3,
        },
        {
          title: 'Heavy Equipment',
          total: '3 Vessels',
          bg: 'heavy-equipment-bg',
          icon: HeavyIcon,
          cols: 3,
        },
      ],
      fleetReports: [],
      showEmoji: false,
      textEmoji: '',
      user_id: JSON.parse(localStorage.getItem('profile')).id,
      showModalDetailFleet: false,
      selectedVehicleTypeId: null,
      searchFleet: '',
      loading_fleet: false,
      fleets: [],
      nextLoading: false,
      page: 1,
      pageSize: 12,
      totalPages: 1,
      searchDebounceTimer: null,
      modalView: 'large'
    }
  },
  methods: {
    ...srActions,
    ...vehiclesActions,
    async fetchFleetReports() {
      try {
        this.loading = true
        const body = {
          // start_date: moment(this.dateRange[0]).format('YYYY-MM-DD'),
          // end_date: moment(this.dateRange[1]).format('YYYY-MM-DD'),
        }
        const params = {
          user_id: this.user_id,
        }
        const res = await this.fetchReportAvailabilityDashboard({
          params,
          body,
        })
        this.fleetReports = res.data.filter((item)=> item.title != 'Heavy Equipment')
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    selectEmoji(emoji) {
      this.textEmoji += emoji.data
    },
    toogleDialogEmoji() {
      this.showEmoji = !this.showEmoji;
    },
    async showDetailFleet (fleet) {
      this.selectedVehicleTypeId = fleet.id
      this.page = 1
      this.modalView = 'list'
      await this.fetchFleets()
      this.showModalDetailFleet = true
    },
    async fetchFleets () {
      try {
        this.loading_fleet = true
        const params = {
          page: this.page,
          limit: this.pageSize,
          vehicleTypeId: this.selectedVehicleTypeId,
          search: this.searchFleet && this.searchFleet.trim() !== '' ? this.searchFleet.trim() : undefined,
          active: true
        }
        const { data } = await this.getVehicles(params)
        this.fleets = data.data
        if (data.total && data.perPage) {
          this.totalPages = Math.max(1, Math.ceil(data.total / data.perPage))
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading_fleet = false
        this.nextLoading = false
      }
    },
    nextPage () {
      this.nextLoading = true
      this.page += 1
      this.fetchFleets()
    },
    prevPage () {
      if (this.page > 1) {
        this.page -= 1
        this.fetchFleets()
      }
    },
    onSearchInput () {
      // debounce 400ms
      if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer)
      this.searchDebounceTimer = setTimeout(() => {
        this.page = 1
        this.fetchFleets()
      }, 400)
    }
  },
  mounted() {
    this.fetchFleetReports()
  },
}
</script>
<style>
.card-container {
  background: white;
  border: 0;
  border-radius: 10px;
  padding: 12px;
  position: relative;
  /* border: 1px solid; */
  transition: transform 0.25s ease;
}

.card-container .card-title-wrap {
  border: 0;
  border-radius: 8px;
  padding: 8px;
}

.card-container .card-image {
  position: absolute;
  right: 24px;
  top: 10px;
  transition: transform 0.3s ease;
}

.card-container:hover {
  transform: scale(1.03);
}

.card-container:hover .card-image {
  transform: scale(1.25);
}

.bg-blue-navy {
  background: #2553ad;
}

.active-bg {
  background: #017aff;
}

.standby-bg {
  background: #334697;
}

.breakdown-bg {
  background: #ff0000;
}

.progress-bg {
  background: #ffa500;
}

.icon {
  width: 58px;
  height: 58px;
}

.text-yellow {
  color: #ffff00;
}

.heavy-equipment-bg {
  background: #800080;
}

.bg-striped {
  background: #f9fafb;
}
</style>
